import { gql } from "@apollo/client"
import { BillingCycleSelectFragment } from "@pallet/features/PartnershipTierType/BillingCycleSelector/fragments"

export const TierOverviewSectionFragment = gql`
    fragment TierOverviewSectionFragment on CollectivePassType {
        id
        name
        description
        isHighlightedTier
        ...BillingCycleSelectFragment
    }
    ${BillingCycleSelectFragment}
`
